/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { ApplicationStatusRequestDto } from '../model/applicationStatusRequestDto';
import { ApplicationStatusResponseDto } from '../model/applicationStatusResponseDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ApplicationStatusControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * getApplicationStaus
     * 
     * @param applicationStatusRequest applicationStatusRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getApplicationStausUsingPOST(applicationStatusRequest: ApplicationStatusRequestDto, observe?: 'body', reportProgress?: boolean): Observable<ApplicationStatusResponseDto>;
    public getApplicationStausUsingPOST(applicationStatusRequest: ApplicationStatusRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApplicationStatusResponseDto>>;
    public getApplicationStausUsingPOST(applicationStatusRequest: ApplicationStatusRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApplicationStatusResponseDto>>;
    public getApplicationStausUsingPOST(applicationStatusRequest: ApplicationStatusRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (applicationStatusRequest === null || applicationStatusRequest === undefined) {
            throw new Error('Required parameter applicationStatusRequest was null or undefined when calling getApplicationStausUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApplicationStatusResponseDto>(`${this.basePath}/application/status`,
            applicationStatusRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
